import { SearchMigrationAdapter } from 'stores/adapters/bex-api/migration-adapters';
import { DefaultRequestFields, HotelResultsViewModel } from 'models';
import { OperationResult, PropertySearch } from '__generated__/api';
import { createSearchAndFilterDisplayOptions, mapSortAndFilter } from 'stores/adapters/bex-api/search/search-sort-filter-adapter';

export const adaptSortAndFilters: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertySearch.Query>
): HotelResultsViewModel => ({
  ...bffResults,
  sortAndFilter: mapSortAndFilter(bexApiResults.data.propertySearch),
  searchAndFilterDisplayOptions: createSearchAndFilterDisplayOptions(bexApiResults.data.propertySearch.sortAndFilter),
  defaultRequestFields: mapDefaultRequestFields(bffResults.defaultRequestFields, bexApiResults.data.propertySearch.searchCriteria)
});

const mapDefaultRequestFields = (
  bffDefaultRequestFields: DefaultRequestFields,
  searchCriteria: PropertySearch.SearchCriteria
): DefaultRequestFields => {
  const defaultRequestFields: DefaultRequestFields = { ...bffDefaultRequestFields };

  if (searchCriteria.sort != null) {
    defaultRequestFields.sort = searchCriteria.sort;
  }

  if (searchCriteria.destination != null) {
    const destination = searchCriteria.destination;
    if (destination.regionId != null) {
      defaultRequestFields.regionId = destination.regionId;
    }
    if (destination.regionName != null) {
      defaultRequestFields.destination = destination.regionName;
    }
  }

  Object.keys(searchCriteria.filters).forEach(filter => {
    const filterVal = searchCriteria.filters[filter];
    if (filterVal != null) {
      // temporary hack until universal sort and filter. see: https://expedia.slack.com/archives/GJY77CBQX/p1567010905012000
      if (filter === 'reviewScore') {
        defaultRequestFields[filterDict[filter]] = (filterVal.min * 10).toString();
      } else if (Array.isArray(filterVal)) {
        defaultRequestFields[filterDict[filter]] = filterVal.map(x => x.toString());
      } else if (typeof filterVal === 'string') {
        defaultRequestFields[filterDict[filter]] = filterVal;
      }
    }
  });

  return defaultRequestFields;
};

const filterDict = {
  sort: 'sort',
  accessibility: 'accessibility',
  amenities: 'amenities',
  deals: 'deals',
  propertyName: 'hotelName',
  structureTypes: 'lodging',
  paymentType: 'paymentType',
  poi: 'poi',
  priceBuckets: 'price',
  reviewScore: 'guestRating',
  starList: 'star',
  travelerType: 'travelerType'
};
